/** @format */

import React from "react";
import { IMAGES } from "../../constants/constants";
import { goToAppOrStore } from "../../helper/helper";

// Persistent "Download App" bar shown on the invite/post-view page, mobile
// only (see .download-app-banner in style.css). Unlike DownloadAppModal, this
// has no close button and isn't gated behind a timeout — it stays on screen
// for the whole time the visitor is on the page, so the download CTA survives
// the modal being dismissed. Uses the same goToAppOrStore() OneLink flow as
// the modal so both send users through identical logic.
export default function DownloadAppBanner({ postId, invitationId }) {
  return (
    <div className="download-app-banner">
      <img
        alt="Paths logo"
        src={IMAGES.PATHS_COLOUR_LOGO.default}
        className="download-app-banner-logo"
      />
      <span className="download-app-banner-text">Get the Paths app</span>
      <button
        className="download-app-banner-btn"
        onClick={() => goToAppOrStore(postId, invitationId)}
      >
        Download App
      </button>
    </div>
  );
}
